import React from 'react';
import { Newspaper } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

export default function AdminBlog() {
  return (
    <AdminCRUD
      endpoint="blog"
      title="Blog Posts"
      icon={Newspaper}
      columns={[
        { key:'title', label:'Post', render:(v,item) => (
          <div className="flex items-center gap-3">
            {item.image
              ? <img src={item.thumbImage||item.image} alt={v} className="w-11 h-11 rounded-xl object-cover flex-shrink-0" />
              : <div className="w-11 h-11 rounded-xl bg-gray-100 flex items-center justify-center text-gray-400 flex-shrink-0">📰</div>}
            <div>
              <div className="font-semibold text-gray-900 text-sm line-clamp-1">{v}</div>
              <div className="text-xs text-gray-400">{item.authorName} · <span className="capitalize">{item.category}</span></div>
            </div>
          </div>
        )},
        { key:'views', label:'Views', render: v => <span className="text-xs text-gray-500">👁 {v||0}</span> },
        { key:'isPublished', label:'Status', render: v => <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${v?'bg-emerald-100 text-emerald-700':'bg-amber-100 text-amber-700'}`}>{v?'Published':'Draft'}</span> },
        { key:'isFeatured', label:'Featured', render: v => v ? <span className="text-gold-500 font-bold">★</span> : <span className="text-gray-300">—</span> },
        { key:'publishedAt', label:'Published', render: v => <span className="text-xs text-gray-400">{v ? new Date(v).toLocaleDateString('en-NG') : '—'}</span> },
      ]}
      defaultForm={{ title:'', category:'news', content:'', excerpt:'', image:'', authorName:'SAAI Team', isPublished:false, isFeatured:false }}
      formFields={[
        { key:'image', label:'Cover Image', type:'image', fullWidth:true },
        { key:'title', label:'Post Title', required:true, fullWidth:true },
        { key:'authorName', label:'Author Name' },
        { key:'category', label:'Category', type:'select', options:['news','update','story','announcement','report','impact','events','health','education','environment'] },
        { key:'excerpt', label:'Short Summary / Excerpt', type:'textarea', fullWidth:true, rows:3 },
        { key:'content', label:'Full Content', type:'textarea', fullWidth:true, required:true, rows:10 },
        { key:'tags', label:'Tags (comma-separated)', fullWidth:true },
        { key:'isPublished', label:'Publish', type:'checkbox', checkLabel:'Publish this post (visible on website)', fullWidth:true },
        { key:'isFeatured', label:'Feature', type:'checkbox', checkLabel:'Feature on homepage', fullWidth:true },
      ]}
    />
  );
}
